import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import PhoneIcon from "@mui/icons-material/Phone";
import {
  company,
  contact,
  externalLinks,
  nav,
} from "../../../utils/siteContent";
import { StyledFooter } from "../../styled/footer";
import { StyledLayout } from "../../styled/layout";
import Logo from "../logo/logo";

const socialIcons = {
  instagram: InstagramIcon,
  linkedin: LinkedInIcon,
  facebook: FacebookIcon,
};

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <StyledFooter.Root>
      {/* Banner CTA */}
      <StyledLayout.Container>
        <StyledFooter.Cta>
          <div>
            <h2>¿Listos para dar el próximo paso?</h2>
            <p>
              Sumate a las organizaciones que ya digitalizaron su medicina
              laboral con Access.
            </p>
          </div>
          <StyledLayout.Button href="#contacto" variant="light">
            Solicitá asesoramiento <NorthEastIcon />
          </StyledLayout.Button>
        </StyledFooter.Cta>
      </StyledLayout.Container>

      <StyledLayout.Container>
        <StyledFooter.Inner>
          <StyledFooter.Brand>
            <Logo light />
            <p>
              {company.tagline}. Expertos en tecnología para la salud laboral
              desde {company.founded}.
            </p>
            <StyledFooter.Socials>
              {contact.socials.map((s) => {
                const Ic = socialIcons[s.icon];
                return (
                  <a
                    key={s.name}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer noopener"
                    aria-label={s.name}>
                    <Ic />
                  </a>
                );
              })}
            </StyledFooter.Socials>
          </StyledFooter.Brand>

          <StyledFooter.Col>
            <h4>Navegación</h4>
            {nav.map((n) => (
              <a key={n.href} href={n.href}>
                {n.label}
              </a>
            ))}
            <a href={externalLinks.blog}>Blog</a>
          </StyledFooter.Col>

          <StyledFooter.Col>
            <h4>Soluciones</h4>
            <a href="#que-hacemos">Prestadores de Medicina Laboral</a>
            <a href="#que-hacemos">Servicios Médicos de Empresas</a>
            <a href="#que-hacemos">Aseguradoras (ART)</a>
            <a href={externalLinks.clientAccess}>Acceso Clientes</a>
            <a href={externalLinks.mlPoint}>ML Point</a>
          </StyledFooter.Col>

          <StyledFooter.Col>
            <h4>Contacto</h4>
            <a href={`tel:${contact.phoneHref}`}>
              <PhoneIcon /> {contact.phone}
            </a>
            <a href={`mailto:${contact.email}`}>
              <MailOutlineIcon /> {contact.email}
            </a>
            <StyledFooter.Certs>
              <span>ISO 9001:2015</span>
              <span>Great Place to Work® {year}</span>
            </StyledFooter.Certs>
          </StyledFooter.Col>
        </StyledFooter.Inner>
      </StyledLayout.Container>

      <StyledLayout.Container>
        <StyledFooter.Bottom>
          <p>
            © {year} {company.name}. Todos los derechos reservados.
          </p>          
        </StyledFooter.Bottom>
      </StyledLayout.Container>
    </StyledFooter.Root>
  );
};

export default Footer;
